import * as Yup from 'yup'

const CareerDetailFormValidations = () => {
    return Yup.object().shape({
    })
}

export { CareerDetailFormValidations }